import {RuntimeConfig} from "../../config/runtime-config";

export const buildWebformUrl = (bankId: string, invitationToken: string): string => {
    return RuntimeConfig.getWebformUrl()
        .replace('{bankId}', bankId)
        .replace('{token}', invitationToken);
}
